import styled from 'styled-components';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';

export const ButtonsList = styled(Vertical).attrs({ gap: 0 })`
  border: 1px solid var(--c-nd-100);
  border-radius: var(--unit);
  overflow: hidden;

  & > *:not(:last-child) {
    border-bottom: 1px solid var(--c-nd-100);
  }

  & > button,
  & > a {
    display: flex;
    align-items: center;
    padding: var(--double-unit);
    gap: var(--double-unit);
    text-align: left;
    background: var(--c-nd-100);
    color: var(--c-nd-700);
    border: none;
    cursor: pointer;
    font: inherit;
    text-decoration: none;
    &:hover,
    &:focus {
      background: var(--c-nd-200);
      color: var(--c-white);
    }
    > *:first-child:not(:last-child) {
      max-width: 32px;
    }
  }
`;
